import React from "react";

interface QRDownloadCardProps {
  title: string;
  description: string;
  qrImage: string; // URL o path a la imagen del QR
}

const QRDownloadCard: React.FC<QRDownloadCardProps> = ({
  title,
  description,
  qrImage,
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 rounded-[24px] w-[390px] mx-auto relative">
      {/* Título */}
      <h1 className="font-montserrat font-bold text-[18px] text-[#1A1A1A] mb-2">
        {title}
      </h1>

      {/* Descripción */}
      <p className="font-montserrat text-[14px] text-[#6D707E] text-center mb-4 leading-[20px]">
        {description}
      </p>

      {/* Imagen QR con borde definido */}
      <div
        className="p-4 rounded-[16px] relative"
        style={{
          background: "white",
          border: "2px solid #CDD0DC", // Borde definido
          boxShadow: "",
        }}
      >
        <img src={qrImage} alt="QR Code" className="w-[150px] h-[150px]" />
      </div>
    </div>
  );
};

export default QRDownloadCard;
